export const league = {
  // Page header
  title: "Monthly League",
  subtitle: "Five assigned opponents per month. Climb the ranks.",
  backHome: "← Home",

  // Stats card
  stats: {
    rating: "Rating",
    passes: "Passes",
    played: "Played",
    won: "Won",
    refused: "Refused",
  },

  // Join CTA
  join: {
    title: "Join This Month's League",
    body1: "Acework will assign you {{count}} opponents over the month.",
    body2:
      "Each match must be played within 7 days of assignment. You'll get 5 refusal passes for scheduling conflicts. Skipped or unplayed matches affect your rating.",
    button: "Join League",
    joining: "Joining...",
  },

  // Slots
  slot: {
    matchLabel: "Match {{num}}",
    unassigned: "Waiting for assignment",
    pending: "Opponent assigned — accept or pass",
    accepted: "Scheduled — go play",
    played: "Played",
    refused: "Refused (pass used)",
    forfeit: "Forfeit (deadline passed)",
    bye: "Bye (no opponent available)",
    ratingLabel: "Rating {{rating}}",
    deadline: "Deadline: {{date}}",
    win: "✓ Win",
    loss: "✗ Loss",
    ratingDelta: "({{delta}} rating)",
    accept: "Accept",
    usePass: "Use Pass",
    recordScore: "Record Score",
    confirmRefuse:
      "Use a refusal pass (免战券)? You have a limited number per month.",
  },
};

export const rating = {
  label: "Acework Rating",
  overall: "Overall Rating",
  entryLabel: "Entry Rating",
  primaryLabel: "Primary Rating",
  unranked: "Unranked",
  matchesShort: "{{count}} matches",
  outOf: "/ 16.50",
  placement: "Placement · {{played}}/{{total}}",
  rankedMatches: "Ranked Matches",
  tierBeginner: "Beginner",
  tierRecreational: "Recreational",
  tierClub: "Club",
  tierStrongClub: "Strong Club",
  tierAdvanced: "Advanced",
  tierHighLevel: "High-Level",
  tierSemiPro: "Semi-Pro",
  tierElite: "Elite",
};
